import React, { useCallback } from 'react';
import { PromptVariable, PromptVariableViewModel } from '../../types';
import { VariableOfStringTypeFields } from './VariableOfStringTypeFields';
import { VariableOfListTypeItems } from './VariableOfListTypeItems';
import { useCreateVariableMutation } from '../hooks/useCreateVariableMutation';
import { useUpdateVariableMutation } from '../hooks/useUpdateVariableMutation';

export const VariableBox = (props: {
  item: PromptVariableViewModel;
  showName?: boolean;
  hideNameValue?: boolean;
}) => {
  const { item, showName, hideNameValue } = props;
  const { mutate: createVariableMutation } = useCreateVariableMutation();
  const { mutate: updateVariableMutation } = useUpdateVariableMutation();
  const onUpdate = useCallback(
    (promptVariable: PromptVariable) =>
      promptVariable.id
        ? updateVariableMutation(promptVariable)
        : createVariableMutation(promptVariable),
    [updateVariableMutation, createVariableMutation]
  );

  return (
    <div
      className="variables-table__variable-container"
      data-test="variables-table__variable-container"
    >
      {showName && !item.hideName && (
        <div className="variables-table__name-header" data-test="variables-table__name-header">
          <div>
            <span
              data-test="variables-table__name-header-text"
              className="text-capitalize growegy-font14--weight500 growegy-font--neutral900 growegy-font-em"
            >
              {item.nameLabel || item.variableValue.name}
            </span>
          </div>
        </div>
      )}
      {item.variableValue.type === 'string' && (
        <VariableOfStringTypeFields
          variable={item}
          onUpdate={onUpdate}
          hideNameValue={hideNameValue}
        />
      )}
      {item.variableValue.type === 'list' && (
        <VariableOfListTypeItems variable={item} onUpdate={onUpdate} />
      )}
    </div>
  );
};
